import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className="bg-primary">
            <div className="row d-flex">
                <div className="col-lg-12 col-sm-12  mt-2 mb-2 text-center text-white">
                    Copyright © 2021 || SmartEDU All rights reserved.
                </div>
            </div>
        </div>
    );
};

export default Footer;
